import * as ActionTypes from 'hellospa/common/constants/condor/action-types';

function showNotice(state, { type, message }) {
  const id = Math.round(Math.random() * 10000);

  return {
    ...state,
    notices: state.notices.concat([{
      id,
      message,
      type,
    }]),
  };
}

function closeNotice(state, { id }) {
  return {
    ...state,
    notices: state.notices.filter((n) => n.id !== id),
  };
}

function clearNotices(state) {
  return {
    ...state,
    notices: [],
  };
}

const Reducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.SHOW_NOTICE:
      return showNotice(state, action.payload);
    case ActionTypes.CLOSE_NOTICE:
      return closeNotice(state, action.payload);
    case ActionTypes.CLEAR_NOTICES:
      return clearNotices(state);
    default:
      return state;
  }
};

export default Reducer;
